import { Component, OnInit } from '@angular/core';

// para recargar pagina de HelperService
@Component({
  selector: 'app-pagina-vacia',
  template: ``,
})
export class PaginaVaciaComponent {
}